"use client";

import { Root } from "@radix-ui/react-aspect-ratio";

export const AspectRatio = Root;
